import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Span } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
var VALUE_PROP_ICON_SIZE = 32;
export var ShowroomValueTitleBanner = function() {
    var layoutElement = React.useContext(Context).layoutElement;
    var isSSR = useIsSSR();
    var main_text = layoutElement.main_text, main_text_color = layoutElement.main_text_color, tagline_text = layoutElement.tagline_text, tagline_text_color = layoutElement.tagline_text_color, layout_element_data = layoutElement.layout_element_data, background_color = layoutElement.background_color;
    var vettingCriteriaData = layout_element_data.map(function(data) {
        return data.simple_image_title;
    }).filter(isNotUndefined);
    var hasVettingCriteria = vettingCriteriaData.length > 0;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        justify: "center",
        $backgroundColor: background_color,
        children: [
            main_text && tagline_text ? /*#__PURE__*/ _jsxs(TitleContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Span, {
                        variant: "displaySSerifRegular",
                        color: main_text_color ? main_text_color : Core.text.inverse,
                        children: main_text
                    }),
                    " ",
                    /*#__PURE__*/ _jsx(Span, {
                        variant: "displaySSerifRegular",
                        color: tagline_text_color ? tagline_text_color : Core.text.subdued,
                        children: tagline_text
                    })
                ]
            }) : null,
            hasVettingCriteria ? /*#__PURE__*/ _jsx(VettingCriteriaWrapper, {
                children: vettingCriteriaData.map(function(vettingCriteria) {
                    var image = vettingCriteria.image, main_text = vettingCriteria.main_text, main_text_color = vettingCriteria.main_text_color;
                    if (image === undefined || !main_text) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsxs(VettingCriteria, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                style: {
                                    width: "".concat(VALUE_PROP_ICON_SIZE, "px"),
                                    height: "".concat(VALUE_PROP_ICON_SIZE, "px")
                                },
                                src: optimizeImageUrlFillSquare(image, isSSR, VALUE_PROP_ICON_SIZE)
                            }),
                            /*#__PURE__*/ _jsx(Span, {
                                color: main_text_color,
                                children: main_text
                            })
                        ]
                    }, main_text);
                })
            }) : null
        ]
    });
};
var horizontalPaddingStyles = css([
    "padding-left:",
    ";",
    "{padding-left:",
    ";}",
    "{padding-left:",
    ";}"
], getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("3x"), responsiveMediaQueries.desktopAndAbove, getSpacing("8x"));
var Wrapper = styled(Column).attrs({
    gap: "2x"
}).withConfig({
    componentId: "sc-467b1701-0"
})([
    "width:100%;overflow:hidden;padding:",
    ";",
    ""
], getSpacing("3x", "1x"), function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor ? css([
        "background-color:",
        ";"
    ], $backgroundColor) : css([
        "background-color:",
        ";"
    ], Core.surface.enabled);
});
var TitleContainer = styled.div.withConfig({
    componentId: "sc-467b1701-1"
})([
    "",
    ";"
], horizontalPaddingStyles);
var VettingCriteria = styled(Row).attrs({
    gap: 8
}).withConfig({
    componentId: "sc-467b1701-2"
})([
    "white-space:nowrap;"
]);
var VettingCriteriaWrapper = styled(Row).attrs({
    gap: 32
}).withConfig({
    componentId: "sc-467b1701-3"
})([
    "overflow:auto;",
    " &::-webkit-scrollbar{-webkit-appearance:none;height:0;}&::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,0);}"
], horizontalPaddingStyles);
